import Layout from "@/components/Layout";
import Footer from "@/components/Footer";
import Hero from "@/components/Hero";
import HomepageTiles from "@/components/HomepageTiles";
import CompactRewardCard from "@/components/CompactRewardCard";
import Stats from "@/components/Stats";
import SocialLinks from "@/components/SocialLinks";
import KickStreamEmbed from "@/components/KickStreamEmbed";
import ContactUs from "@/components/ContactUs";
import AboutSection from "@/components/AboutSection";
import gamdomBg from "@/assets/gamdom-bg.png";
import hypedropLogo from "@/assets/hypedrop-logo.png";
import Seo from "@/components/Seo";
const Index = () => {
  return <Layout>
      <Seo
        title="GamDucks — VIP Gaming Rewards, Giveaways & Bonuses"
        description="Claim exclusive VIP rewards, daily login bonuses and giveaways at GamDucks. Join the community earning real prizes through Rainbet and HypeDrop."
        path="/"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "GamDucks",
            url: "https://gamducks.com",
            logo: "https://gamducks.com/favicon.png",
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "GamDucks",
            url: "https://gamducks.com",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://gamducks.com/support?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          },
        ]}
      />
      <div className="min-h-screen bg-gradient-primary">
        <main>
          <Hero />
          
          <HomepageTiles />


          <Stats />
          <SocialLinks />
          <KickStreamEmbed />
          <AboutSection />
          
          
        </main>

        <Footer />
      </div>
    </Layout>;
};
export default Index;